var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQuran(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 42,
    viewBox: "0 0 36 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M35 31H6C3.23858 31 1 33.2386 1 36C1 38.7614 3.23858 41 6 41H35",
    stroke: "#5784F7",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M35 41C32.2386 41 30 38.7614 30 36C30 33.2386 32.2386 31 35 31",
    stroke: "#5784F7",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M23.8675 18.9999C22.7368 20.8763 20.6795 22.1313 18.329 22.1313C14.7604 22.1313 11.8675 19.2384 11.8675 15.6698C11.8675 13.3194 13.1225 11.262 14.999 10.1313",
    stroke: "#5784F7",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line",
    d: "M21 13H21.018",
    stroke: "#5784F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M1 36V8C1 4.13401 4.13401 1 8 1H28C31.866 1 35 4.13401 35 8V31",
    stroke: "#5784F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuran);
export default __webpack_public_path__ + "static/media/IconQuran.e87bac0211d6bda4cc62ef484bc9fecc.svg";
export { ForwardRef as ReactComponent };